import type { FunctionComponent } from 'react';

import { Layout } from '@kanda-libs/ks-design-library';

import { JobButton, MobileHeader } from 'components';

import { Rates } from './components';

interface MobileCreditLineProps {
  isLoading: boolean;
  isSubmitting: boolean;
  hasApplicableLoans: boolean;
  selectNewRate: boolean;
}

const Mobile: FunctionComponent<MobileCreditLineProps> = function ({
  isLoading,
  isSubmitting,
  hasApplicableLoans,
  selectNewRate,
}) {
  return (
    <Layout header={<MobileHeader showTrustPilot={false} />} noBorder noPadding>
      <div className="flex flex-col flex-1 -mb-6 mt-4">
        <div className="w-full px-4 py-2 mx-auto mb-12 max-w-128 mb-2">
          <JobButton compact />
        </div>
        <div className="flex flex-col flex-1 bg-neutral-000">
          <div className="flex flex-col flex-1 w-full px-6 mx-auto max-w-128">
            <div className="flex flex-col mb-6">
              {hasApplicableLoans ? (
                <Rates
                  isLoading={isLoading}
                  isSubmitting={isSubmitting}
                  selectNewRate={selectNewRate}
                />
              ) : (
                <p>No applicable loans</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

Mobile.displayName = 'Quote-Content-Mobile-view';

export default Mobile;
